import { useLazyQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import {
  TagPickerFragment,
  WasteLineUnifiedInput,
} from "generated-graphql/graphql";
import { transform } from "hooks/transform/transformWasteLineUnified";
import { useCallback } from "react";

export type WasteLineUnifiedFormData = {
  willNotReport: boolean;
  lineItem: string | null;
  dotDescription: string | null;
  vendorAmount: number | null;
  eManifestAmount: number | null;
  vendorProfileNumber: string | null;
  vendorManagementMethodCode: string | null;
  tags: TagPickerFragment[];
};

const VALIDATE_WASTE_LINE_UNIFIED_INPUT = gql(`
  query ValidateWasteLineUnifiedInput($input: WasteLineUnifiedInput!) {
    wasteLineUnifiedInputValidator(input: $input) {
      ...issue
    }
  }
`);

export function useWasteLineUnifiedInputValidation() {
  const [query] = useLazyQuery(VALIDATE_WASTE_LINE_UNIFIED_INPUT, {
    fetchPolicy: "no-cache",
  });

  return useCallback(
    async (input: WasteLineUnifiedInput) => {
      const transformedInput = transform(input);
      const { data: result, previousData } = await query({
        variables: { input: transformedInput },
      });

      return result
        ? result?.wasteLineUnifiedInputValidator
        : previousData?.wasteLineUnifiedInputValidator ?? [];
    },
    [query]
  );
}
